import { Instagram } from "lucide-react";
import { SOCIALS } from "../data/site";

// Order: Facebook, Instagram, LinkedIn, X, YouTube
const ORDER = ["facebook", "instagram", "linkedin", "twitter", "youtube"];

export const SocialIcons = ({ size = 44 }) => {
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="social-icons">
      {ORDER.map((key) => {
        const s = SOCIALS[key];
        if (!s) return null;
        const sizeStyle = { width: size, height: size };
        return (
          <a
            key={key}
            href={s.url}
            target="_blank"
            rel="noreferrer"
            aria-label={s.label}
            data-testid={`social-${key}`}
            className="group relative rounded-xl overflow-hidden bg-white shadow-[0_6px_20px_rgba(0,0,0,0.25)] ring-1 ring-white/10 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_28px_rgba(197,160,89,0.35)] hover:ring-[#c5a059]/60"
            style={sizeStyle}
          >
            {s.icon ? (
              <img
                src={s.icon}
                alt={s.label}
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
            ) : (
              // Instagram gradient fallback
              <span
                className="absolute inset-0 flex items-center justify-center text-white"
                style={{
                  background:
                    "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
                }}
              >
                <Instagram size={size * 0.55} strokeWidth={2} />
              </span>
            )}
            <span className="absolute inset-0 ring-0 group-hover:ring-2 ring-[#c5a059]/60 rounded-xl transition-all" />
          </a>
        );
      })}
    </div>
  );
};
